import React,{useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {UPDATE_PAGE_URL, NON_EDITABLE_STATUS, VERIFY_PAGE_URL} from '../../../constants';
import useRedirect from '../hooks/useRedirection'
import KycInfoUI from '../../../stories/components/Onboarding/KycInfo/KycInfoUI';
import {sendEvarData} from '@ibibo/analytics';
import * as actions from '../../../store/actions/index';
import { tokenSelector, errorSelector, businessTypeListSelector, docTypeListSelector, userDetailsSelector, statusSelector, nextLoader, gstLoaderSelector, additionalDocSelector } from '../../../store/selectors';

const KycInfo = props => {

  const history = useHistory();
  const dispatch = useDispatch();

  const data = useSelector(userDetailsSelector);

  const token = useSelector(tokenSelector);
  const error = useSelector(errorSelector);
  const status = useSelector(statusSelector);
  const businessTypeList = useSelector(businessTypeListSelector);
  // const businessTypeList = {
  //   "em": "Employee",
  //   "hf": "HUF",
  //   "jv": "Joint Venture",
  //   "lt": "Limited",
  //   "pp": "Partnership",
  //   "pt": "Pvt Ltd Company",
  //   "sp": "Sole Proprietership"
  // }
  const docTypeList = useSelector(docTypeListSelector);
  // const docTypeList = {
  //   "eb": "Electricity Bill",
  //   "bs": "Bank Statement"
  // }
  const setLoader = useSelector(nextLoader);
  const gstLoader = useSelector(gstLoaderSelector);
  const [popUp, showModal, setShowModal] = useRedirect();
  const additionalDocType = useSelector(additionalDocSelector);
  // const additionalDocType = {
  //   "ua": "Udhyog Aadhar",
  //   "cc": "Crossed Cheque",
  //   "gstnc": "GSTN Certificate"
  // };

  const uploadPan = ({panNumber, agencyName, panFile, successCallBack}) => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|documentUpload|PAN"
    }, true)
    let fd = new FormData();
    fd.append('agency_name', agencyName);
    fd.append('pan_number', panNumber);
    fd.append('token', token);
    fd.append('document_type', 'pancard');
    fd.append('file', panFile, 'panImage.png');
    dispatch(actions.submitPAN(fd, panNumber, agencyName, successCallBack))
  };

  const cancelPan = () => {
    dispatch(actions.resetPANInfo());
  };

  const errorCallBack = () => {
    setShowModal(true)
    dispatch(actions.submitKYCModalInfo('updated'))
  };

  const uploadKYC = ({kycFile, kycDocType}) => {
    sendEvarData({
      prop54: `myPartner|signup|businessVerification|documentUpload|${kycDocType}`
    }, true)
    let fd = new FormData();
    fd.append('token', token);
    fd.append('document_type', kycDocType);
    fd.append('file', kycFile, 'kycImage.png');
    dispatch(actions.submitKYC(fd, kycDocType));
  };

  const uploadFacade = ({facadeFile}) => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|documentUpload|facade"
    }, true)
    let fd = new FormData();
    fd.append('token', token);
    fd.append('document_type', 'fd');
    fd.append('file', facadeFile, 'fdImage.png');
    dispatch(actions.submitFacade(fd, 'fd'));
  };

  const successCallback = () => {
    history.push(`${UPDATE_PAGE_URL}`);

    const fbPixel = `<script>!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '313388378811698');fbq('track', 'myPartner_Lead');</script><noscript><img height="1" width="1" style="display:none"src="https://www.facebook.com/tr?id=313388378811698&ev=PageView&noscript=1"/></noscript>`;
    let tag = document.createElement('script');
    tag.innerHTML = `${fbPixel}`
  }

  const submitInfo = dataObj => {
    if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
      successCallback();
      return;
    }
    const dataToSubmit = {
      token: token,
      agency_name: dataObj.agencyName,
      pan_number: dataObj.panNumber,
      gstn: dataObj.gstNumber,
      business_type: dataObj.businessType,
      address: dataObj.address,
      state: dataObj.state,
      city: dataObj.city,
      pincode: dataObj.pincode,
      kyc_type: dataObj.kycDocType
    };
    let fd = new FormData();
    for (var key in dataToSubmit) {
      fd.append(key, dataToSubmit[key]);
    }
    dispatch(actions.submitData(fd, dataToSubmit, successCallback, errorCallBack));
  };

  return (
    <>
      {popUp}
      <KycInfoUI
      data={data}
      error={error}
      status={status}
      submitDetails={data => submitInfo(data)}
      onUpload={data => uploadPan(data)}
      cancelPAN={data => cancelPan()}
      uploadKYC={data => uploadKYC(data)}
      uploadFacade={data => uploadFacade(data)}
      businessTypeList={businessTypeList}
      kycDocList={docTypeList}
      setLoader={setLoader}
      gstLoader={gstLoader}
      addDocList={additionalDocType}
      />
      </>
      );
    };

    export default KycInfo;
